import { FilterOption } from './types/types';

export const hasCommonTag = (candidates: string[], options: FilterOption[]) => {
  return candidates.some((val) => options.includes(val));
};